module.exports = __webpack_public_path__ + "img/Asset 2@2x.10b4b051.png";